import React, { Component } from 'react';
import _ from 'lodash';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Info } from '../../../assets/svg/info.svg';
import Select from 'react-select';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import { toast } from 'react-toastify';
import Modal from '../../components/modals';
import InputHeader from '../../components/global/inputwithHeader';

const getEvent = gql`
	query RootQuery($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			projectTitle
			name
			crew {
				count
				managerIds
				role
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			equipments {
				eqId
				qrCode
				status
				isReceived
				__typename
				userId
			}
		}
	}
`;
const getTenantUsersList = gql`
	query TenantUsersList($workspaceIds: [String!]!) {
		tenantUsersList(workspaceIds: $workspaceIds) {
			id
			firstName
			lastName
			email
			isEmailVerified
		}
	}
`;
const getEquipment = gql`
	query EquipmentList($eqIdentifier: [String!]!) {
		equipmentInfo(eqIdentifier: $eqIdentifier) {
			id
			qrCode
			ownerType
			ownerId
			type
			comment {
				_id
				comment
				createdAt
				createdBy
			}
			model
			description
			manufacturer
			manufacturerId
			status
			lastUsedBy {
				tenantId
				workspaceId
				projectId
				projectName
				projectSlNo
				eventId
				eventName
				eventSlNo
				userId
				userName
				usedAt
			}
			createdBy
			createdAt
			updatedBy
			updatedAt
			branch {
				_id
				branchId
			}
		}
	}
`;
const assignEquipmentMutation = gql`
	mutation RootMutation(
		$workspaceId: String!
		$qrCodes: [String!]!
		$assignedTo: LogUserInput!
		$projectId: ID
		$eventId: ID
	) {
		assignEquipment(
			workspaceId: $workspaceId
			qrCodes: $qrCodes
			assignedTo: $assignedTo
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

const assignUnregisteredEquipments = gql`
	mutation AssignUnregisteredEq(
		$workspaceId: String!
		$projectId: ID!
		$eventId: ID!
		$unregisteredEqs: [AssignUnregisteredEqInput]
		$notes: String
		$assignedTo: LogUserInput!
	) {
		assignUnregisteredEq(
			workspaceId: $workspaceId
			projectId: $projectId
			eventId: $eventId
			unregisteredEqs: $unregisteredEqs
			notes: $notes
			assignedTo: $assignedTo
		) {
			message
		}
	}
`;

class AsssignEquipment extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			actionType: 'assign',
			isLoading: true,
			qrCode: '',
			manufacturerId: '',
			qrCodeError: false,
			qrCodeDuplicate: false,
			assignedCrew: null,
			tenantUsersList: {},
			eventDetails: {},
			equipments: [],
			isAssignedEquipmentLoading: false,
			showBusyModal: false,
			busyClickedEq: null,
			unRegisterModal: false,
			unregisteredEquipments: [],
			unregisteredEquipmentsForQuery: [],
			descriptionOptionsList: [
				{
					type: 'lightStand',
					label: 'Simpex Light Stand',
					value: 'Simpex Light Stand',
				},
				{
					type: 'lightStand',
					label: 'Sonia Light Stand',
					value: 'Sonia Light Stand',
				},
				{
					type: 'doubleStrap',
					label: 'Mandee Leather Strap Double Strap',
					value: 'Mandee Leather Strap Double Strap',
				},
				{
					type: 'flash',
					label: 'Godox V860-2C Flash',
					value: 'Godox V860-2C Flash',
				},
				{
					type: 'spotLight',
					label: 'Godox ML60 Spot Light',
					value: 'Godox ML60 Spot Light',
				},
				{
					type: 'monopod',
					label: 'Monopod Osaka VH25',
					value: 'Monopod Osaka VH25',
				},
				{
					type: 'micBag',
					label: 'Rode Mic Bag(Includes 3 mics)',
					value: 'Rode Mic Bag(Includes 3 mics)',
				},
				{
					type: 'nanLite',
					label: 'NANLite PavoTube 15c',
					value: 'NANLite PavoTube 15c',
				},
				{
					type: 'nanLite',
					label: 'NANLite PavoTube 30c',
					value: 'NANLite PavoTube 30c',
				},
				{
					type: 'nanLite',
					label: 'NANLite PavoTube II 30x',
					value: 'NANLite PavoTube II 30x',
				},
				{
					type: 'flash',
					label: 'Profoto A1 flash',
					value: 'Profoto A1 flash',
				},
				{
					type: 'flash',
					label: 'Godox AD600 Pro',
					value: 'Godox AD600 Pro',
				},
				{
					type: 'reflector',
					label: 'Hiffin 32.5inch SPL Reflector',
					value: 'Hiffin 32.5inch SPL Reflector',
				},
				{
					type: 'battery',
					label: 'Godox WB400P battery',
					value: 'Godox WB400P battery',
				},
				{
					type: 'tripod',
					label: 'E-Image AT-7402A',
					value: 'E-Image AT-7402A',
				},
				{
					type: 'lens',
					label: 'Nikon 45mm/2.8D',
					value: 'Nikon 45mm/2.8D',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 17-28/2.8S',
					value: 'Nikkor Z 17-28/2.8S',
				},
				{
					type: 'tripod',
					label: 'Manfrotto MVGBF-CF Tripod',
					value: 'Manfrotto MVGBF-CF Tripod',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 28mm/2.8S',
					value: 'Nikkor Z 28mm/2.8S',
				},
				{
					type: 'charger',
					label: 'Profoto B10 Charger',
					value: 'Profoto B10 Charger',
				},
				{
					type: 'flash',
					label: 'Godox V1N Flash',
					value: 'Godox V1N Flash',
				},
				{
					type: 'bag',
					label: 'Mobius Shoulder bag',
					value: 'Mobius Shoulder bag',
				},
				{
					type: 'gimbleBattery',
					label: 'DJI Ronin RSCG18 Gimble Battery',
					value: 'DJI Ronin RSCG18 Gimble Battery',
				},
				{
					type: 'trigger',
					label: 'Godox X2TN Trigger',
					value: 'Godox X2TN Trigger',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 50mm/1.2S',
					value: 'Nikkor Z 50mm/1.2S',
				},
				{
					type: 'bag',
					label: 'Godox AD400 Pro Bag',
					value: 'Godox AD400 Pro Bag',
				},
				{
					type: 'battery',
					label: 'Godox WB400P Battery',
					value: 'Godox WB400P Battery',
				},
				{
					type: 'battery',
					label: 'Godox WB29 Battery',
					value: 'Godox WB29 Battery',
				},
				{
					type: 'lightStand',
					label: 'Photopro Light Stand',
					value: 'Photopro Light Stand',
				},
				{
					type: 'battery',
					label: 'Osaka Small Battery',
					value: 'Osaka Small Battery',
				},
				{
					type: 'bag',
					label: 'Lowepro Bag',
					value: 'Lowepro Bag',
				},
				{
					type: 'drone',
					label: 'DJI Mavic Pro Platinum M1X Drone',
					value: 'DJI Mavic Pro Platinum M1X Drone',
				},
				{
					type: 'lens',
					label: 'Nikon 14-24mm/2.8G',
					value: 'Nikon 14-24mm/2.8G',
				},
				{
					type: 'bag',
					label: 'Pinball Lights Bag',
					value: 'Pinball Lights Bag',
				},
				{
					type: 'bag',
					label: 'Godx AD400 speedLight Bag',
					value: 'Godx AD400 speedLight Bag',
				},
				{
					type: 'flashUmbrellaClamp',
					label: 'Photopro Flash Umbrella Clamp',
					value: 'Photopro Flash Umbrella Clamp',
				},
				{
					type: 'lensMount',
					label: 'Nikkor FTZ',
					value: 'Nikkor FTZ',
				},
				{
					type: 'lensMount',
					label: 'Nikon FTZ II',
					value: 'Nikon FTZ II',
				},
				{
					type: 'chargerCable',
					label: 'Longwell - P 2*0.75sqmm Charger Cable',
					value: 'Longwell - P 2*0.75sqmm Charger Cable',
				},
				{
					type: 'flash',
					label: 'Profoto B10 Flash',
					value: 'Profoto B10 Flash',
				},
				{
					type: 'ndFilter',
					label: 'YH 49mm ND Filter',
					value: 'YH 49mm ND Filter',
				},
				{
					type: 'chargerCable',
					label: 'Godox P2012-L4 Charger cable',
					value: 'Godox P2012-L4 Charger cable',
				},
				{
					type: 'gimbleBattery',
					label: 'Ronin SC Gimble Battery',
					value: 'Ronin SC Gimble Battery',
				},
				{
					type: 'gimble',
					label: 'DJI PRO RSC 2 Gimble',
					value: 'DJI PRO RSC 2 Gimble',
				},
				{
					type: 'bag',
					label: 'Fitech Gimble Bag',
					value: 'Fitech Gimble Bag',
				},
				{
					type: 'lens',
					label: 'Canon 135mm TS-E',
					value: 'Canon 135mm TS-E',
				},
				{
					type: 'lens',
					label: 'Canon 135mm/1.8s',
					value: 'Canon 135mm/1.8s',
				},
				{
					type: 'batteryCharger',
					label: 'Sony FS5 Battery Charger',
					value: 'Sony FS5 Battery Charger',
				},
				{
					type: 'droneCarCharger',
					label: 'DJI C3S80 Mavic Car Drone Charger',
					value: 'DJI C3S80 Mavic Car Drone Charger',
				},
				{
					type: 'trigger',
					label: 'Profoto TTL-N Trigger',
					value: 'Profoto TTL-N Trigger',
				},
				{
					type: 'batteryCharger',
					label: 'Godox Flash Charger',
					value: 'Godox Flash Charger',
				},
				{
					type: 'tripod',
					label: 'Manfortto MVMXPROA4 Tripod',
					value: 'Manfortto MVMXPROA4 Tripod',
				},
				{
					type: 'gimble',
					label: 'Ronin DJI RSC 2 Gimble',
					value: 'Ronin DJI RSC 2 Gimble',
				},
				{
					type: 'cameraMic',
					label: 'Rode Camera Mic',
					value: 'Rode Camera Mic',
				},
				{
					type: 'chargerCable',
					label: 'Local 2*0.75sqmm Charger Cable',
					value: 'Local 2*0.75sqmm Charger Cable',
				},
				{
					type: 'battery',
					label: 'Godox VB18 Battery',
					value: 'Godox VB18 Battery',
				},
				{
					type: 'battery',
					label: 'Godox Battery',
					value: 'Godox Battery',
				},
				{
					type: 'lens',
					label: 'Nikon 17-28mm/2.8S',
					value: 'Nikon 17-28mm/2.8S',
				},
				{
					type: 'batteryCharger',
					label: 'Simpex Dual Digital Battery Charger',
					value: 'Simpex Dual Digital Battery Charger',
				},
				{
					type: 'gimble',
					label: 'DJI Ronin RSC Gimble',
					value: 'DJI Ronin RSC Gimble',
				},
				{
					type: 'bag',
					label: 'Godox LC500R LED Light Stick Bag',
					value: 'Godox LC500R LED Light Stick Bag',
				},
				{
					type: 'trigger',
					label: 'Profoto TTL-N B10 Trigger',
					value: 'Profoto TTL-N B10 Trigger',
				},
				{
					type: 'batteryCharger',
					label: 'TyFy Battery Charger',
					value: 'TyFy Battery Charger',
				},
				{
					type: 'batteryCharger',
					label: 'Profoto Battery Charger',
					value: 'Profoto Battery Charger',
				},
				{
					type: 'speedLight',
					label: 'Godox AD400 Pro Speed Light',
					value: 'Godox AD400 Pro Speed Light',
				},
				{
					type: 'battery',
					label: 'Osaka NP-F750 Small Battery',
					value: 'Osaka NP-F750 Small Battery',
				},
				{
					type: 'atomos',
					label: 'Ninja V Atomos',
					value: 'Ninja V Atomos',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 24-70mm/2.8S',
					value: 'Nikkor Z 24-70mm/2.8S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 70-180mm/2.8S',
					value: 'Nikkor Z 70-180mm/2.8S',
				},
				{
					type: 'battery',
					label: 'Profoto100440 Battery',
					value: 'Profoto100440 Battery',
				},
				{
					type: 'battery',
					label: 'Simpex NP-F770 Battery',
					value: 'Simpex NP-F770 Battery',
				},
				{
					type: 'batteryCharger',
					label: 'Nikon Battery Charger MH-25a',
					value: 'Nikon Battery Charger MH-25a',
				},
				{
					type: 'droneCarCharger',
					label: 'DJI C4S80 Mavic 2 Car Drone Charger',
					value: 'DJI C4S80 Mavic 2 Car Drone Charger',
				},
				{
					type: 'batteryCharger',
					label: 'Godox C400P B1 Flash Battery Charger',
					value: 'Godox C400P B1 Flash Battery Charger',
				},
				{
					type: 'batteryCharger',
					label: 'TyFy Dual Digital Battery Charger',
					value: 'TyFy Dual Digital Battery Charger',
				},
				{
					type: 'cameraMicBag',
					label: 'Moza Camera Mic Bag',
					value: 'Moza Camera Mic Bag',
				},
				{
					type: 'extensionBox',
					label: 'Kewals Estension Box',
					value: 'Kewals Estension Box',
				},
				{
					type: 'extensionBox',
					label: 'Kewals Extension Box(6 Port)',
					value: 'Kewals Extension Box(6 Port)',
				},
				{
					type: 'ledLightStick',
					label: 'Godox LC500R LED Light Stick',
					value: 'Godox LC500R LED Light Stick',
				},
				{
					type: 'ledLightStick',
					label: 'Yongnu YN360 III LED Light Stick',
					value: 'Yongnu YN360 III LED Light Stick',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 40mm/2S',
					value: 'Nikkor Z 40mm/2S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 28-75mm/2.8S',
					value: 'Nikkor Z 28-75mm/2.8S',
				},
				{
					type: 'extensionBox',
					label: 'Hoeton Extension Box(10 ports)',
					value: 'Hoeton Extension Box(10 ports)',
				},
				{
					type: 'magmod',
					label: 'Godox AD400 magmod',
					value: 'Godox AD400 magmod',
				},
				{
					type: 'bag',
					label: 'GoMe Lights Bag',
					value: 'GoMe Lights Bag',
				},
				{
					type: 'camera',
					label: 'Nikon Z7 Camera',
					value: 'Nikon Z7 Camera',
				},
				{
					type: 'battery',
					label: 'Godox AD300 Pro Battery',
					value: 'Godox AD300 Pro Battery',
				},
				{
					type: 'bag',
					label: 'Fitech Gimble bag',
					value: 'Fitech Gimble bag',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 24-70mm/4S',
					value: 'Nikkor Z 24-70mm/4S',
				},
				{
					type: 'gimble',
					label: 'Manfrotto MVG 220 Gimble',
					value: 'Manfrotto MVG 220 Gimble',
				},
				{
					type: 'gimble',
					label: 'DJI RSC 3 Gimble',
					value: 'DJI RSC 3 Gimble',
				},
				{
					type: 'gimble',
					label: 'DJI RSC 3Pro Gimble',
					value: 'DJI RSC 3Pro Gimble',
				},
				{
					type: 'battery',
					label: 'Profoto100397 Battery',
					value: 'Profoto100397 Battery',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 70-200mm/2.8S',
					value: 'Nikkor Z 70-200mm/2.8S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 17-28mm/2.8S',
					value: 'Nikkor Z 17-28mm/2.8S',
				},
				{
					type: 'battery',
					label: 'Simpex Small Battery',
					value: 'Simpex Small Battery',
				},
				{
					type: 'battery',
					label: 'Osaka Big Battery',
					value: 'Osaka Big Battery',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 105mm/2.8S',
					value: 'Nikkor Z 105mm/2.8S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 50/1.2S',
					value: 'Nikkor Z 50/1.2S',
				},
				{
					type: 'batteryCharger',
					label: 'Sony Battery Charger',
					value: 'Sony Battery Charger',
				},
				{
					type: 'trigger',
					label: 'Godox X Pro N Trigger',
					value: 'Godox X Pro N Trigger',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 50mm/2.8S',
					value: 'Nikkor Z 50mm/2.8S',
				},
				{
					type: 'flash',
					label: 'Godox AD300Pro Flash',
					value: 'Godox AD300Pro Flash',
				},
				{
					type: 'chargerCable',
					label: 'LineTek 2*0.75sqmm Charger Cable',
					value: 'LineTek 2*0.75sqmm Charger Cable',
				},
				{
					type: 'charger',
					label: 'Godox LC500 LED Light Stick Charger',
					value: 'Godox LC500 LED Light Stick Charger',
				},
				{
					type: 'camera',
					label: 'Nikon Z7 II Camera',
					value: 'Nikon Z7 II Camera',
				},
				{
					type: 'flash',
					label: 'Yongnu YN685 Flash',
					value: 'Yongnu YN685 Flash',
				},
				{
					type: 'bag',
					label: 'Lowepro BP 450 AW II Pro Treker Bag',
					value: 'Lowepro BP 450 AW II Pro Treker Bag',
				},
				{
					type: 'bag',
					label: 'Vanguard Trolley Bag(wheels)',
					value: 'Vanguard Trolley Bag(wheels)',
				},
				{
					type: 'batteryCharger',
					label: 'Welborn Dual Digital Battery Charger',
					value: 'Welborn Dual Digital Battery Charger',
				},
				{
					type: 'bowensMount',
					label: 'Godox AD400 Bowens Mount',
					value: 'Godox AD400 Bowens Mount',
				},
				{
					type: 'batteryCharger',
					label: 'DigiTek Dual Digital Battery Charger',
					value: 'DigiTek Dual Digital Battery Charger',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 24/1.8S',
					value: 'Nikkor Z 24/1.8S',
				},
				{
					type: 'lens',
					label: 'Nikkor F 14-24mm',
					value: 'Nikkor F 14-24mm',
				},
				{
					type: 'droneCarCharger',
					label: 'DJI P1CH Mavic AIR Drone Charger',
					value: 'DJI P1CH Mavic AIR Drone Charger',
				},
				{
					type: 'mic',
					label: 'DJI ASB01 Mic',
					value: 'DJI ASB01 Mic',
				},
				{
					type: 'mic',
					label: 'Rode Wireless II Mic',
					value: 'Rode Wireless II Mic',
				},

				{
					type: 'mic',
					label: 'ASBO1',
					value: 'ASBO1',
				},
				{
					type: 'mic',
					label: 'DJI 2PC',
					value: 'DJI 2PC',
				},
				{
					type: 'mic',
					label: 'DJI 3PC',
					value: 'DJI 3PC',
				},

				{
					type: 'mic',
					label: 'Sennheiser MKE 600 Mic',
					value: 'Sennheiser MKE 600 Mic',
				},
				{
					type: 'mic',
					label: 'Sennheiser MKE 400 Mic',
					value: 'Sennheiser MKE 400 Mic',
				},
				{
					type: 'battery',
					label: 'Nikon Battery',
					value: 'Nikon Battery',
				},
				{
					type: 'bag',
					label: 'Think Tank Bag(wheels)',
					value: 'Think Tank Bag(wheels)',
				},
				{
					type: 'lens',
					label: 'Nikon 16-35mm/4G',
					value: 'Nikon 16-35mm/4G',
				},
				{
					type: 'flash',
					label: 'Profoto A1 Flash',
					value: 'Profoto A1 Flash',
				},
				{
					type: 'droneCharger',
					label: 'DJI F1C50 Drone Charger',
					value: 'DJI F1C50 Drone Charger',
				},
				{
					type: 'droneCharger',
					label: 'DJI F2C60 Drone Charger',
					value: 'DJI F2C60 Drone Charger',
				},
				{
					type: 'batteryCharger',
					label: 'Godox Battery Charger',
					value: 'Godox Battery Charger',
				},
				{
					type: 'camera',
					label: 'Nikon Z6 Camera(supports Atomos)',
					value: 'Nikon Z6 Camera(supports Atomos)',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 50mm/1.8S',
					value: 'Nikkor Z 50mm/1.8S',
				},
				{
					type: 'bag',
					label: 'Profoto Shoulder Bag',
					value: 'Profoto Shoulder Bag',
				},
				{
					type: 'lens',
					label: 'Nikon 28-75mm/2.8S',
					value: 'Nikon 28-75mm/2.8S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 85mm/1.8S',
					value: 'Nikkor Z 85mm/1.8S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 85mm/1.2S',
					value: 'Nikkor Z 85mm/1.2S',
				},
				{
					type: 'batteryCharger',
					label: 'Simpex Battery Charger',
					value: 'Simpex Battery Charger',
				},
				{
					type: 'battery',
					label: 'Sony NP-FZ100 Battery',
					value: 'Sony NP-FZ100 Battery',
				},
				{
					type: 'bag',
					label: 'Lowepro Shoulder Bag',
					value: 'Lowepro Shoulder Bag',
				},
				{
					type: 'flash',
					label: 'Godox AD200 Flash',
					value: 'Godox AD200 Flash',
				},
				{
					type: 'lens',
					label: 'Nikon 105mm/1.4E',
					value: 'Nikon 105mm/1.4E',
				},
				{
					type: 'ndFilter',
					label: 'K & F Concept ND Filter',
					value: 'K & F Concept ND Filter',
				},
				{
					type: 'gimbleCase',
					label: 'Ronin SC Gimble Case',
					value: 'Ronin SC Gimble Case',
				},
				{
					type: 'lens',
					label: 'Nikkor 24mm/1.8S',
					value: 'Nikkor 24mm/1.8S',
				},
				{
					type: 'lightStand',
					label: 'Manfrotto Light Stand',
					value: 'Manfrotto Light Stand',
				},
				{
					type: 'extensionBox',
					label: 'GoldMedal Extension Box(1 Port)',
					value: 'GoldMedal Extension Box(1 Port)',
				},
				{
					type: 'bag',
					label: 'Lowepro BP-350 AW II Pro Runner shoulder bag',
					value: 'Lowepro BP-350 AW II Pro Runner shoulder bag',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 105/2.8S',
					value: 'Nikkor Z 105/2.8S',
				},
				{
					type: 'gimbleTripod',
					label: 'Manfortto MVMXPROA4 Tripod',
					value: 'Manfortto MVMXPROA4 Tripod',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 35mm/1.8S',
					value: 'Nikkor Z 35mm/1.8S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 50/1.8S',
					value: 'Nikkor Z 50/1.8S',
				},
				{
					type: 'flashBattery',
					label: 'Profoto B1 flash Battery',
					value: 'Profoto B1 flash Battery',
				},
				{
					type: 'batteryCharger',
					label: 'Godox C29 AD300 Pro Battery Charger',
					value: 'Godox C29 AD300 Pro Battery Charger',
				},
				{
					type: 'bag',
					label: 'Mobius Lights Bag',
					value: 'Mobius Lights Bag',
				},
				{
					type: 'adapter',
					label: 'Godox C400P AC/DC Adapter',
					value: 'Godox C400P AC/DC Adapter',
				},
				{
					type: 'ledLightStick',
					label: 'Godox LC500 LED Light Stick',
					value: 'Godox LC500 LED Light Stick',
				},
				{
					type: 'droneCharger',
					label: 'DJI P1C50 Drone Charger',
					value: 'DJI P1C50 Drone Charger',
				},
				{
					type: 'ndFilter',
					label: 'Hifffin ND Filter',
					value: 'Hifffin ND Filter',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 105/1.4E',
					value: 'Nikkor Z 105/1.4E',
				},
				{
					type: 'lens',
					label: 'Nikkor Z MC 105/2.8S',
					value: 'Nikkor Z MC 105/2.8S',
				},
				{
					type: 'softBox',
					label: 'Godox 80cm Softbox',
					value: 'Godox 80cm Softbox',
				},
				{
					type: 'softBox',
					label: 'Profoto B10 Soft Box(honey comb, 1 diffusers)',
					value: 'Profoto B10 Soft Box(honey comb, 1 diffusers)',
				},
				{
					type: 'softBox',
					label: 'Godox AD-S60S Soft Box(honey comb, 3 diffusers)',
					value: 'Godox AD-S60S Soft Box(honey comb, 3 diffusers)',
				},
				{
					type: 'bag',
					label: 'Lowepro BP 450 AW II Pro Treker Bag(wheels)',
					value: 'Lowepro BP 450 AW II Pro Treker Bag(wheels)',
				},
				{
					type: 'lens',
					label: 'Nikon 28mm/2.8S',
					value: 'Nikon 28mm/2.8S',
				},
				{
					type: 'sungun',
					label: 'Photopro V-4 Sun Gun',
					value: 'Photopro V-4 Sun Gun',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 58/0.95S',
					value: 'Nikkor Z 58/0.95S',
				},
				{
					type: 'flash',
					label: 'Profoto B1 flash',
					value: 'Profoto B1 flash',
				},
				{
					type: 'batteryCharger',
					label: 'Li-ion Battery Charger',
					value: 'Li-ion Battery Charger',
				},
				{
					type: 'camera',
					label: 'Nikon Z6 II Camera',
					value: 'Nikon Z6 II Camera',
				},
				{
					type: 'camera',
					label: 'Nikon Zf Camera',
					value: 'Nikon Zf Camera',
				},
				{
					type: 'camera',
					label: 'Nikon Z8 Camera',
					value: 'Nikon Z8 Camera',
				},
				{
					type: 'bag',
					label: 'Think Tank Bag',
					value: 'Think Tank Bag',
				},
				{
					type: 'bag',
					label: 'Pinball Shoulder bag',
					value: 'Pinball Shoulder bag',
				},
				{
					type: 'camera',
					label: 'Nikon Z50 Camera',
					value: 'Nikon Z50 Camera',
				},
				{
					type: 'camera',
					label: 'Nikon Z30 Camera',
					value: 'Nikon Z30 Camera',
				},
				{
					type: 'charger',
					label: 'Godox LC500R LED Light Stick Charger',
					value: 'Godox LC500R LED Light Stick Charger',
				},
				{
					type: 'batteryCharger',
					label: 'DigiTek Battery Charger',
					value: 'DigiTek Battery Charger',
				},
				{
					type: 'lens',
					label: 'Nikkor 3.5-6.3mm',
					value: 'Nikkor 3.5-6.3mm',
				},
				{
					type: 'gimble',
					label: 'DJI Ronin RSC 2 Gimble',
					value: 'DJI Ronin RSC 2 Gimble',
				},
				{
					type: 'gimble',
					label: 'DJI Ronin RSC 1 Gimble',
					value: 'DJI Ronin RSC 1 Gimble',
				},
				{
					type: 'battery',
					label: 'Profoto100440 B10 Battery',
					value: 'Profoto100440 B10 Battery',
				},
				{
					type: 'lens',
					label: 'Nikon 14-30mm/4s',
					value: 'Nikon 14-30mm/4s',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 20mm/1.8S',
					value: 'Nikkor Z 20mm/1.8S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 24-120mm/4S',
					value: 'Nikkor Z 24-120mm/4S',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 40/2S',
					value: 'Nikkor Z 40/2S',
				},
				{
					type: 'camera',
					label: 'Nikon Z6 Camera',
					value: 'Nikon Z6 Camera',
				},
				{
					type: 'softBox',
					label: 'Godox AD-S65S Soft Box(honey comb, 3 diffusers)',
					value: 'Godox AD-S65S Soft Box(honey comb, 3 diffusers)',
				},
				{
					type: 'lens',
					label: 'Nikon 45mm/2.8ED',
					value: 'Nikon 45mm/2.8ED',
				},
				{
					type: 'micBag',
					label: 'Rode Mic Bag(Includes 2 mics)',
					value: 'Rode Mic Bag(Includes 2 mics)',
				},
				{
					type: 'batteryCharger',
					label: 'Envie Battery Charger',
					value: 'Envie Battery Charger',
				},
				{
					type: 'ledLight',
					label: 'Simpex Flash Light',
					value: 'Simpex Flash Light',
				},
				{
					type: 'drone',
					label: 'DJI Mavic 2 Pro L1P Drone',
					value: 'DJI Mavic 2 Pro L1P Drone',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 24mm/1.8S',
					value: 'Nikkor Z 24mm/1.8S',
				},
				{
					type: 'batteryAdapter',
					label: 'DJI Mavic AIR 2 Power Bank Adapter',
					value: 'DJI Mavic AIR 2 Power Bank Adapter',
				},
				{
					type: 'lens',
					label: 'Nikkor Z 24-70/2.8S',
					value: 'Nikkor Z 24-70/2.8S',
				},
				{
					type: 'flash',
					label: 'Phottix Mitros+ Flash',
					value: 'Phottix Mitros+ Flash',
				},
				{
					type: 'battery',
					label: 'Godox VB26 Battery',
					value: 'Godox VB26 Battery',
				},
				{
					type: 'tripod',
					label: 'E-Image EH730 Tripod',
					value: 'E-Image EH730 Tripod',
				},
				{
					type: 'camera',
					label: 'Nikon Z6 Camera(Supports Atomos)',
					value: 'Nikon Z6 Camera(Supports Atomos)',
				},
				{
					type: 'doubleStrap',
					label: 'Double Strap Black Rapid',
					value: 'Double Strap Black Rapid',
				},
				{
					type: 'mic',
					label: 'Se',
					value: 'Double Strap Black Rapid',
				},
			],
		};
		this.timeout = 0;
	}
	componentDidMount = () => {
		let filters = {
			projectId: this.props.params.projectID,
			vendorEventId: this.props.params.shootID,
			workspaceId: this.props.params.workspaceID,
		};

		let filters2 = {
			workspaceIds: [this.props.params.workspaceID],
		};
		this.getShootInfo(getEvent, filters);
		this.getTenantUsersList(getTenantUsersList, filters2);
	};
	renderCrew = () => {
		let crewDetails = [];
		_.map(this.state.eventDetails.crewNew, (crew) => {
			if (crew.isCustomUser !== true && crew.userId !== null) {
				let found = undefined;

				let name = '';
				let isManager = false;
				found = _.find(this.state.tenantUsersList, { id: crew.userId });

				if (found) {
					name = `${found.firstName ? found.firstName : ''}${' '}${
						found.lastName ? found.lastName : ''
					}`;
					isManager = crew.isManager === null ? false : crew.isManager;
				}

				let data = { id: crew.userId, name, isManager };
				crewDetails.push(data);
			}

			return crew;
		});

		let arr = [];
		_.forEach(crewDetails, (item, key) => {
			arr.push({ value: item.id, label: item.name });
		});
		return (
			<Select
				className={`cost-select-container zIndex3 w-100p `}
				classNamePrefix="cost-select"
				onChange={(e) => this.handleEditCrewName(e)}
				isSearchable={true}
				options={arr}
				value={
					_.filter(arr, {
						value: this.state.assignedCrew,
					})[0]
				}
			/>
		);
	};
	handleEditCrewName = (e) => {
		this.setState({
			assignedCrew: e.value,
			assignedCrewUserName: e.label,
		});
	};
	handleEventChange = async (e, name) => {
		this.setState(
			{
				qrCode: e.target.value,
				qrCodeError: false,
				qrCodeErrorMessage: '',
			},
			() => {
				if (this.timeout) clearTimeout(this.timeout);
				this.timeout = setTimeout(async () => {
					if (
						_.size(
							_.filter(this.state.equipments, {
								qrCode: e.target.value,
							}),
						) > 0 ||
						_.size(
							_.filter(this.state.equipments, {
								manufacturerId: e.target.value,
							}),
						) > 0
					) {
						this.setState({
							qrCodeError: true,
							qrCodeErrorMessage: 'Equipment Already Assigned',
						});
					} else if (
						e.target.value !== '' &&
						e.target.value.length >= 4 &&
						_.size(
							_.filter(this.state.equipments, {
								manufacturerId: e.target.value,
							}),
						) == 0 &&
						_.size(
							_.filter(this.state.equipments, {
								qrCode: e.target.value,
							}),
						) == 0
					) {
						let json = { eqIdentifier: e.target.value };

						await this.getEquipmentInfo(getEquipment, json);
					}
				}, 1000);
			},
		);
	};

	renderSummary = () => {
		let data = _.chain(this.state.equipments)
			.groupBy((x) => x.type)
			.map((value, key) => ({
				type: key,
				size: _.size(value),
				group: _.chain(value)
					.groupBy((x) => x.model)
					.map((value, key) => ({ model: key, group: value }))
					.value(),
			}))
			.value();

		return (
			<>
				{data.length > 0
					? _.map(data, (item, key) => {
							return (
								<a>
									<h2>
										<p>{item.type}</p>
									</h2>
									<label>{item.size}</label>
									{_.map(item.group, (grp, k) => {
										return (
											<span>
												<h2>
													<p>{grp.group[0]['description']}</p>
												</h2>{' '}
												<label>{_.size(grp.group)}</label>
											</span>
										);
									})}
								</a>
							);
					  })
					: ''}
				{_.size(this.state.unregisteredEquipments) > 0 ? (
					<a>
						<h2>
							<p>Unregistered Equipments</p>
						</h2>
						<label>{_.size(this.state.unregisteredEquipments)}</label>
						{_.map(
							_.groupBy(this.state.unregisteredEquipments, (x) => x.description),
							(eq, k) => {
								return (
									<span>
										<h2>
											<p>{k}</p>
										</h2>{' '}
										<label>{_.size(eq)}</label>
									</span>
								);
							},
						)}
					</a>
				) : null}
			</>
		);
	};
	isDisabled = (busyEqs) => {
		if (
			_.size([...this.state.equipments, ...this.state.unregisteredEquipmentsForQuery]) == 0 ||
			this.state.assignedCrew == null ||
			_.size(busyEqs) > 0
		) {
			return true;
		} else {
			return false;
		}
	};
	handleAssignEquipment = async (e) => {
		let eventId = this.props.params.shootID;
		let projectId = this.props.params.projectID;
		let workspaceId = this.props.params.workspaceID;
		let qrCodes = [];
		_.forEach(this.state.equipments, (equipment, key) => {
			qrCodes.push(equipment.qrCode);
		});
		let json = {
			qrCodes: qrCodes,
			assignedTo: {
				id: this.state.assignedCrew,
				name: this.state.assignedCrewUserName,
			},
			eventId,
			projectId,
			workspaceId,
		};

		let jsonUnregisterEq = {
			workspaceId,
			projectId,
			eventId,
			unregisteredEqs: this.state.unregisteredEquipmentsForQuery,
			assignedTo: {
				id: this.state.assignedCrew,
				name: this.state.assignedCrewUserName,
			},
		};

		let resp =
			_.size(qrCodes) > 0
				? await this.assignEquipment(assignEquipmentMutation, json)
				: [true];
		let respUnRegister =
			_.size(this.state.unregisteredEquipmentsForQuery) > 0
				? await this.assignEquipment(assignUnregisteredEquipments, jsonUnregisterEq)
				: [true];

		if (resp[0] == false) {
			//this.handleCloseModal();
			toast.error(
				_.has(resp[1], 'message') ? resp[1]['message'] : 'Failed to Assign Equipments',
				{
					position: 'top-right',
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: 'light',
				},
			);
		} else if (respUnRegister[0] == false) {
			toast.error(
				_.has(respUnRegister[1], 'message')
					? respUnRegister[1]['message']
					: 'Failed to Assign Unregistered Equipments',
				{
					position: 'top-right',
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: 'light',
				},
			);
		} else {
			toast.success('Equipment Assigned Successfully!', {
				position: 'top-right',
				autoClose: 500,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
			this.props.navigate(
				`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}`,
			);
		}
	};
	deleteItem = (e, qrCode) => {
		let equipments = [...this.state.equipments];
		this.setState({
			equipments: _.filter(equipments, function (o) {
				return o.qrCode !== qrCode;
			}),
		});
	};
	deleteUnregisteredEq = (e, index) => {
		let unregisteredEquipments = [...this.state.unregisteredEquipments];
		let unregisteredEquipmentsForQuery = [...this.state.unregisteredEquipmentsForQuery];

		unregisteredEquipments.splice(index, 1);
		unregisteredEquipmentsForQuery.splice(index, 1);

		this.setState({
			unregisteredEquipments,
			unregisteredEquipmentsForQuery,
		});
	};
	goBack = (e) => {
		this.props.navigate(-1);
	};

	toggleUnRegisterModal = () => {
		this.setState({
			unRegisterModal: !this.state.unRegisterModal,
		});
	};

	registerUnAssignedEquipments = () => {
		let unregisteredEquipments = this.state.unregisteredEquipments;
		for (let index = 0; index < this.state.quantity; index++) {
			unregisteredEquipments.push({
				manufacturerId: this.state.manufacturerId,
				description: this.state.description,
			});
		}

		let unregisteredEquipmentsForQuery = this.state.unregisteredEquipmentsForQuery;
		unregisteredEquipmentsForQuery.push({
			manufacturerId: this.state.manufacturerId,
			description: this.state.description,
			quantity: parseInt(this.state.quantity),
		});

		this.setState({
			description: null,
			manufacturerId: '',
			quantity: 0,
			unRegisterModal: false,
			unregisteredEquipments,
			unregisteredEquipmentsForQuery,
		});
	};

	handleBusyInfo = (eq) => {
		this.setState({
			busyClickedEq: eq,
			showBusyModal: true,
		});
	};

	render() {
		let busyEqs;
		busyEqs = _.filter(this.state.equipments, { status: 'busy' });
		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div className="assign-receive-container">
						<div className="arc-header">
							{/* <div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div> */}
							<div className="arch-item">
								<span>Workspace</span>
								<b>{this.props.params.workspaceID}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Project</span>
								<b>{this.state.eventDetails.projectTitle}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Shoot</span>
								<b>{this.state.eventDetails.name}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Assign Equipment</span>
							</div>
						</div>
						<div className="arc-body">
							<div className="arcb-left">
								<div
									className="qrhitem column-20w"
									style={{
										display: 'flex',
										flexDirection: 'row',
									}}
								>
									<div style={{ width: '70%' }}>
										<input
											value={this.state.qrCode}
											placeholder="Type QR Code"
											autoFocus={true}
											onChange={(e) => this.handleEventChange(e, 'qrCode')}
										/>
										{this.state.isEQFetching ? (
											<div className={'loading-btn'}>
												<LoadingBar />
											</div>
										) : this.state.qrCodeError ? (
											<p>{this.state.qrCodeErrorMessage}</p>
										) : (
											''
										)}
									</div>
									<div className={'unregisterEquipmentComponent'}>
										<span>Or</span>
										<div
											className={'unregisterButton'}
											onClick={() => this.toggleUnRegisterModal()}
										>
											Add Unregistered
										</div>
									</div>
								</div>
								<div className="arcbl-list">
									<div className="assign-hdd-item ">
										<div className="column column-20w">
											<span>EQ id</span>
											<span>Branch</span>
											<span>Serial No.</span>
											<span>description</span>

											<span></span>

											{/* <span>damage</span> */}
										</div>

										{_.size(this.state.equipments) > 0 ||
										_.size(this.state.unregisteredEquipments) > 0 ? (
											<>
												{_.map(
													this.state.equipments,

													(equipment, key) => {
														return (
															<div
																className="hitem column-20w listHitem"
																style={{
																	color:
																		equipment.status === 'busy'
																			? 'red'
																			: '#fff',
																}}
															>
																<span
																	style={{
																		display: 'flex',
																		alignItems: 'center',
																	}}
																	onClick={(e) =>
																		equipment.status ===
																			'busy' &&
																		this.handleBusyInfo(
																			equipment,
																		)
																	}
																>
																	{equipment.qrCode}
																	{equipment.status === 'busy' ? (
																		<b
																			style={{
																				display: 'flex',
																				alignItems:
																					'center',
																				marginLeft: 5,
																			}}
																		>
																			<Info />
																		</b>
																	) : (
																		''
																	)}
																</span>
																<span
																	onClick={(e) =>
																		equipment.status ===
																			'busy' &&
																		this.handleBusyInfo(
																			equipment,
																		)
																	}
																>
																	{equipment.branch?.branchId ||
																		'VEHYD'}
																</span>
																<span
																	onClick={(e) =>
																		equipment.status ===
																			'busy' &&
																		this.handleBusyInfo(
																			equipment,
																		)
																	}
																>
																	{equipment.manufacturerId}
																</span>
																<span
																	onClick={(e) =>
																		equipment.status ===
																			'busy' &&
																		this.handleBusyInfo(
																			equipment,
																		)
																	}
																>
																	{equipment.description}
																</span>

																<span
																	onClick={(e) =>
																		this.deleteItem(
																			e,
																			equipment.qrCode,
																		)
																	}
																>
																	{' '}
																	<Delete />
																</span>
															</div>
														);
													},
												)}
												{_.map(
													this.state.unregisteredEquipments,

													(equipment, key) => {
														return (
															<div
																className="hitem column-20w listHitem"
																style={{
																	color:
																		equipment.status === 'busy'
																			? 'orange'
																			: '#fff',
																}}
															>
																<span>{'Unregistered'}</span>
																<span>
																	{equipment.manufacturerId}
																</span>
																<span>{'Unregistered'}</span>
																<span>{equipment.description}</span>

																<span
																	onClick={(e) =>
																		this.deleteUnregisteredEq(
																			e,
																			equipment.qrCode,
																		)
																	}
																>
																	{' '}
																	<Delete />
																</span>
															</div>
														);
													},
												)}
											</>
										) : (
											<div className="empty">
												<p>
													No Equipment Added <br />
													Please scan or type in the equipment ID
												</p>
											</div>
										)}
									</div>
								</div>
							</div>
							<div className="arcb-right">
								{/* <div className="arcbr-top-inputs">
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Workspace</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.props.params.workspaceID}
												//value={this.props.params.workspaceID}
												isDisabled={true}
											/>
										</div>
									</div>

									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Project</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.state.eventDetails.projectTitle}
												isDisabled={true}
											/>
										</div>
									</div>
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Event</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.state.eventDetails.name}
												isDisabled={true}
											/>
										</div>
									</div>
								</div> */}
								<div className="arcbr-bottom-inputs" style={{ marginTop: 0 }}>
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Assign To</label>
											{this.renderCrew()}
										</div>
									</div>
								</div>

								<div className="summary">
									<h3>
										Summary (
										{_.size(this.state.equipments) +
											_.size(this.state.unregisteredEquipments)}
										)
									</h3>
									{this.renderSummary()}
								</div>
								<div className="btn">
									{this.state.isAssignedEquipmentLoading === false ? (
										<a
											className={
												this.isDisabled(busyEqs)
													? 'add-edit-btn disabled'
													: 'add-edit-btn'
											}
											onClick={(e) => {
												if (!this.isDisabled(busyEqs)) {
													this.handleAssignEquipment();
												}
											}}
										>
											Assign Equipment
										</a>
									) : (
										<span className={'add-edit-btn loading-btn'}>
											<LoadingBar />
											Assign Equipment
										</span>
									)}
								</div>
							</div>
						</div>
					</div>
				)}
				{this.state.showBusyModal === false ? null : (
					<Modal
						handleClose={() =>
							this.setState({ showBusyModal: false, busyClickedEq: null })
						}
						show={this.state.showBusyModal}
						modalType={'center'}
					>
						<div className="busy-modal">
							<div className="bm-header">EQUIPMENT ERROR</div>
							<div className="bm-body">
								<span>
									{this.state.busyClickedEq?.description
										? `${this.state.busyClickedEq?.description} - `
										: ''}
									{this.state.busyClickedEq?.manufacturer}{' '}
									{this.state.busyClickedEq?.model}{' '}
									{_.capitalize(this.state.busyClickedEq?.type)} |{' '}
									{this.state.busyClickedEq?.qrCode} is already assigned to{' '}
									{this.state.busyClickedEq?.lastUsedBy.userName} for{' '}
									{this.state.busyClickedEq?.lastUsedBy.projectName}{' '}
									{this.state.busyClickedEq?.lastUsedBy.eventName}
								</span>
								<p>
									Please remove the above mentioned equipment to complete the
									assignment.
								</p>
							</div>
							<div className="bm-footer">
								<a
									onClick={() =>
										this.setState({
											showBusyModal: false,
											busyClickedEq: null,
										})
									}
								>
									Okay, Got it
								</a>
							</div>
						</div>
					</Modal>
				)}
				<Modal
					key={this.state.unRegisterModal}
					handleClose={() => this.toggleUnRegisterModal()}
					show={this.state.unRegisterModal}
					modalType={'center'}
				>
					<div className="busy-modal">
						<div className="bm-header">ADD UNREGISTERED EQUIPMENTS</div>
						<div className="bm-body">
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<div
									className="floating-select-container"
									style={{
										display: 'block',
										float: 'left',
										margin: '30px 0px',
										zIndex: 2,
									}}
								>
									<label>Description*</label>
									<Select
										className="cost-select-container w-100p fixed-select-container"
										classNamePrefix="cost-select"
										options={this.state.descriptionOptionsList}
										onChange={(e) =>
											this.setState({
												description: e.value,
											})
										}
										defaultValue={
											_.filter(this.state.descriptionOptionsList, {
												value: this.state.description,
											})[0]
										}
										isSearchable={true}
									/>
								</div>
								<div
									className="mc-section-item"
									style={{
										marginTop: '35px',
									}}
								>
									<InputHeader
										type="text"
										name="manufacturerId"
										width={'100%'}
										marginBottom={'35px'}
										value={this.state.manufacturerId}
										onChange={(e) =>
											this.setState({
												manufacturerId: e.target.value,
												quantity: e.target.value === '' ? 0 : 1,
											})
										}
										isInputError={false}
										label="Serial Number"
									/>
								</div>
								<div className="mc-section-item">
									<InputHeader
										type="number"
										name="quantity"
										value={this.state.quantity}
										width={'100%'}
										marginBottom={'10px'}
										onChange={(e) =>
											this.setState({
												quantity: e.target.value,
											})
										}
										isInputError={false}
										readOnly={
											_.size(this.state.manufacturerId) > 0 ? true : false
										}
										label="Quantity *"
									/>
								</div>
							</div>
						</div>
						<div className="bm-footer" style={{ marginTop: '0px' }}>
							<a
								onClick={() => this.registerUnAssignedEquipments()}
								style={{
									margin: '0px 15px',
									background: 'linear-gradient(90deg, #9256D9 0%, #5F55EC 100%)',
									color: '#fff',
									width: '200px',
								}}
							>
								Proceed
							</a>
						</div>
					</div>
				</Modal>
			</>
		);
	}
}

export default withRouter(AsssignEquipment);
